const Logo = () => {
    return (
        <img alt="logo" className='w-64' src={require('../assets/logo.png')}></img>
    )
}

export default Logo;